export const NEW_DOCUMENTS = "[DOCUMENTS] NEW_DOCUMENTS";
